import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { format, parseISO, roundToNearestMinutes } from 'date-fns';
import { Schedule } from '../../../_shared/models/match.model';

@Component({
  standalone: false,
    selector: 'app-match-schedule',
    templateUrl: './match-schedule.component.html',
    styleUrls: ['./match-schedule.component.scss'],
})
export class MatchScheduleComponent implements AfterViewInit {
    @ViewChild('schedulepopover') schedulePopover: any;

    @Input() schedule: Schedule;
    @Input() min: string;
    @Input() max: string;

    date: Date;

    @Output() setSchedule: EventEmitter<Schedule> = new EventEmitter();

    constructor() { }

    ngAfterViewInit() {
        // console.log(this.min);

        if (this.min) {
            this.schedulePopover.min = format(new Date(this.min), 'yyyy-MM-ddTHH:mm');
        }

        // if (this.max) {
        //     this.schedulePopover.max = format(new Date(this.max), 'yyyy-MM-dd')
        // }

        if (this.schedule && this.schedule?.scheduledDate && this.schedule?.scheduledTime) {
            this.date = new Date(`${this.schedule.scheduledDate}T${this.schedule.scheduledTime}`);
        } else {
            this.date = roundToNearestMinutes(new Date(), { nearestTo: 30 });
            this.schedulePopover.value = this.date;
            this.emitSchedule();
        }
    }

    async changeDatetime(ev) {
        this.date = parseISO(ev.detail.value);
        this.emitSchedule();
    }

    emitSchedule() {
        const schedule: Schedule = {
            scheduledDate: format(this.date, 'yyyy-MM-dd'),
            scheduledTime: format(this.date, 'HH:mm'),
            timezoneOffset: new Date().getTimezoneOffset()
        }

        this.setSchedule.emit(schedule);
    }



}
